import { jsx as _jsx } from "react/jsx-runtime";
import { MenuContext } from '#pplx/frontend/aether/components/internal/menu/useMenuContext.js';
import { useMobileBottomSheetContext } from '#pplx/frontend/aether/components/internal/menu/useMobileBottomSheetContext.js';
/**
 * Menu provider that manages both mobile menu state
 * and desktop submenu registry for scroll-triggered closing.
 *
 * This component can be used in two ways:
 * 1. At the root Menu level: Creates a default submenu registry
 * 2. At each MenuOverlay level: Accepts a custom registry for hierarchical submenu management
 */
export function MenuProvider({ children, submenus, menuItems, footerRegistry, headerRegistry, hasWidthConstraint, }) {
    const mobileBottomSheetContext = useMobileBottomSheetContext();
    const defaultSubmenus = {
        closeAll: () => { },
        closeOthers: () => { },
        register: () => { },
        unregister: () => { },
    };
    const defaultMenuItems = {
        register: () => { },
        unregister: () => { },
        focusFirstMenuItem: () => { },
    };
    const contextValue = mobileBottomSheetContext?.close != null
        ? {
            isMobileBottomSheet: true,
            closeMobileMenu: mobileBottomSheetContext.close,
            submenus: submenus ?? defaultSubmenus,
            menuItems: menuItems ?? defaultMenuItems,
            footerRegistry,
            headerRegistry,
            hasWidthConstraint,
        }
        : {
            isMobileBottomSheet: false,
            submenus: submenus ?? defaultSubmenus,
            menuItems: menuItems ?? defaultMenuItems,
            footerRegistry,
            headerRegistry,
            hasWidthConstraint,
        };
    return _jsx(MenuContext.Provider, { value: contextValue, children: children });
}
//# sourceMappingURL=MenuContext.js.map